<template>
	<div class="order-buttons">
		<ECommerceAddToCartButton
			:product="eCommerceProduct"
			:segment="segment"
			:is-sub-item="isSubItem"
			:size="size"
			:disabled="(inventory <= 0 && requiresStock) || disableAddToCart"
			:ignoreStock="ignoreStock"
		/>
	</div>
</template>
<script>
import { ProductCategory } from "~/components/ecommerce/types/ProductCategory.js";
import ECommerceProductMixin from "../../ECommerceProductMixin/ECommerceProductMixin.js";
import { mapState } from "vuex";

export default defineNuxtComponent({
	mixins: [ECommerceProductMixin],
	props: ["disableAddToCart", "size", "modalProps", "ignoreStock"],

	data() {
		return {
			host: undefined,
		};
	},

	computed: {
		...mapState("ecommerce", ["categoriesThatRequireStock"]),
		segment() {
			return this.$store.getters["ecommerce/segment"];
		},
		inventory() {
			return this.eCommerceProduct?.inventory?.[0]?.amount || 0;
		},
		isSubItem() {
			return [ProductCategory.ACCESSORY, ProductCategory.SOUND, ProductCategory.ROUTER].includes(
				this.eCommerceProduct?.category,
			);
		},
		requiresStock() {
			return this.categoriesThatRequireStock.includes(this.eCommerceProduct?.category);
		},
	},

	mounted() {
		this.host = window.location.host;
	},
});
</script>
<style lang="scss" scoped>
.order-buttons {
	display: flex;
	justify-content: stretch;

	> div {
		width: 100%;

		&:nth-child(2) {
			margin-left: $spacing-m;
		}
	}

	@include breakpoint(mobile) {
		flex-direction: column;

		> div {
			width: 100%;

			&:nth-child(2) {
				margin-left: 0;
			}
		}
	}
}
</style>
